import { useRef, useState, useEffect } from "react";

function HelpIcon({ size = 22 }) {
    return (
        <svg viewBox="0 0 24 24" width={size} height={size} aria-hidden style={{ display: "block", pointerEvents: "none" }}>
            <circle cx="12" cy="12" r="10" fill="currentColor" opacity="0.45" />
            <path d="M12 7a3 3 0 00-3 3h2a1 1 0 112 0c0 1-1 1.5-1.7 2.1-.6.5-1.3 1.1-1.3 2.4h2c0-.7.3-1 .9-1.5C13.8 12.4 15 11.6 15 10a3 3 0 00-3-3zm-1 9v2h2v-2h-2z" fill="#fff" />
        </svg>
    );
}

function HelpPopoverStyles() {
    return (
        <style>{`
            /* HelpPopover 주변 레이아웃 안전장치 */
            .help-wrap{ position: relative; display: inline-block; z-index: 2; }
            .help-wrap svg, .help-wrap svg *{ fill: unset; }

            .btn.btn--help{ width: 24px; height: 24px; border-radius: 50%; display: inline-grid; place-items: center; background: #c3d8f5ff; color: #5488a0ff; border: 0; padding: 0; line-height: 1; }

            .btn--help { --help-bg:#cfe6ff; --help-fg:#0ea5e9; background:var(--help-bg); color:var(--help-fg); }
            .btn--help svg circle { fill: currentColor !important; }
            .btn--help svg path   { fill: #06316dff !important; }
            .btn--help:hover { --help-bg:#d9ecff; }

            .popover{ position: absolute; top: 50%; left: 100%; transform: translate(8px, -50%); min-width: 260px; max-width: 360px; background: #fff; border: 1px solid #e5e7eb; border-radius: 10px; box-shadow: 0 8px 24px rgba(0,0,0,.08); padding: 12px; z-index: 999; }
            .popover__title{ font-weight:700; margin-bottom:6px; }
            .popover__body{ font-size:13px; line-height:1.4; }
            .popover__actions{ text-align:right; margin-top:8px; }
        `}</style>
    );
}

export default function HelpPopover({ title = "도움말", children }) {
    const [open, setOpen] = useState(false);
    const btnRef = useRef(null);
    const popRef = useRef(null);

    useEffect(() => {
        // 외부 클릭 닫기(필요 시 유지/삭제)
        const handleDocClick = (e) => {
            if (!popRef.current || !btnRef.current) return;
            const inPop = popRef.current.contains(e.target);
            const inBtn = btnRef.current.contains(e.target);
            if (!inPop && !inBtn) setOpen(false);
        };
        if (open) document.addEventListener("click", handleDocClick, { capture: true });
        return () => document.removeEventListener("click", handleDocClick, { capture: true });
    }, [open]);

    return (
        <div className="help-wrap">
            <HelpPopoverStyles />
            <button
                type="button"
                ref={btnRef}
                className="btn btn--help"
                title="업로드 형식 가이드"
                aria-expanded={open}
                onClick={(e) => {
                    e.stopPropagation();
                    setOpen((v) => !v);
                }}
            >
                <HelpIcon />
            </button>

            {open && (
                <div
                    ref={popRef}
                    role="dialog"
                    aria-label={title}
                    className="popover"
                    onClick={(e) => e.stopPropagation()}
                >
                    <div className="popover__title">{title}</div>
                    <div className="popover__body">{children}</div>
                    <div className="popover__actions">
                        <button type="button" className="btn btn--ghost" onClick={() => setOpen(false)}>
                            닫기
                        </button>
                    </div>
                </div>
            )}
        </div>
    );
}
